import { styled as styledMui5 } from '@mui/material/styles';
import NextLinkMui5 from 'components/atoms/NextLink';
import { StyledButtonMui5 } from 'components/atoms/StyledButton';
import Popover, { PopoverAnchorType } from 'components/molecules/Popover';
import {
  isAdminSelector,
  isSalesSelector,
} from 'containers/deal/recoil/selectors';
import { useGTagTrackOfferCard } from 'hooks/useGTagTrackOfferCard';
import { FC, MouseEvent } from 'react';
import { useRecoilValue } from 'recoil';
import { AuctionFromSearch } from 'shared/types/api/getAuctions';
import VehicleOptions from '../VehicleOptions';
import styles from './index.module.css';

const FeaturesTextMui5 = styledMui5('span')(
  ({ theme }) => `
  line-height: 1rem;
  margin: ${theme.spacing(-1, 0)};`,
);

const Container = styledMui5('div')`
  display: grid;
  grid-template-columns: repeat(2, 1fr);`;

const Content = styledMui5('div')(
  ({ theme }) => `
  margin: ${theme.spacing(1, 0.5)};
  margin-bottom: 0;
  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }`,
);

type Props = {
  auction: AuctionFromSearch;
};

export const OfferCardFooter: FC<Props> = ({ auction }) => {
  const { gtagTrackOfferCardClick, gtagTrackOfferCardFeaturesClick } =
    useGTagTrackOfferCard();

  const isSales = useRecoilValue(isSalesSelector);
  const isAdmin = useRecoilValue(isAdminSelector);

  return (
    <Container>
      <Content>
        {isSales || isAdmin ? (
          <StyledButtonMui5
            color='primary'
            fullWidth
            variant='outlined'
            component={NextLinkMui5}
            href={`/admin/calc/${auction.id}`}
          >
            Quote
          </StyledButtonMui5>
        ) : (
          <Popover
            anchorType={PopoverAnchorType.StyledButton}
            buttonProps={{
              variant: 'outlined',
              children: <FeaturesTextMui5>Vehicle Features</FeaturesTextMui5>,
              size: 'small',
              className: styles.rightButton,
              sx: { width: '100%', height: '100%' },
            }}
            onOpen={gtagTrackOfferCardFeaturesClick}
            openOnClick
            popoverProps={{
              transformOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
              onClick: (event: MouseEvent<HTMLDivElement>) => {
                event.stopPropagation();
                event.preventDefault();
              },
            }}
          >
            <VehicleOptions
              features={auction.offer.features}
              options={auction.offer.options
                .filter((option) => option.msrpMax > 0)
                .sort((o1, o2) => o2.msrpMax - o1.msrpMax)}
              showDescription={false}
            />
          </Popover>
        )}
      </Content>
      <Content>
        <StyledButtonMui5
          color='primary'
          fullWidth
          component={NextLinkMui5}
          href={`/deals/${auction.id}`}
          // eslint-disable-next-line
          // @ts-ignore: onClick is not a valid prop for StyledButton
          onClick={() => {
            gtagTrackOfferCardClick();
          }}
        >
          VIEW DEAL
        </StyledButtonMui5>
      </Content>
    </Container>
  );
};

OfferCardFooter.displayName = 'OfferCardFooter';
